// extracted by mini-css-extract-plugin
export default {"pageWrap":"za-z","fullWidth":"Aa-z","heading":"Ba-z","fullBleed":"Ca-z","hidden":"Da-z"};